import { render } from "./DataPrivacy.vue?vue&type=template&id=434d51dc&ts=true"
import script from "./DataPrivacy.vue?vue&type=script&lang=ts"
export * from "./DataPrivacy.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__